import '@styles/pages/article.scss';

import { initCarousel } from '@organisms/carousel';
import { initOfferCard } from '@organisms/offer-card';
import { flickitySliderBySelector } from '@organisms/flickity-continuous-slider';
import { initSelectionBusHandler } from '@organisms/selection-bus-handler';
import { selectionSliderManager } from '@organisms/selection-slider-manager';

flickitySliderBySelector('.content-blocks__item--logos');
initCarousel();
initOfferCard();
initSelectionBusHandler();
selectionSliderManager();
